import StopRoundedIcon from "@material-ui/icons/StopRounded";
import RouterRoundedIcon from "@material-ui/icons/RouterRounded";
import React from "react";
import "./color-square.scss";

interface PropsFromParent {
  color: string;
}

export class ColorSquare extends React.PureComponent<PropsFromParent> {
  private iconStyle = { color: this.props.color };
  public render() {
    return (
      <div className="flexDirectionRow">
        <StopRoundedIcon style={this.iconStyle} className="enlarge" />
      </div>
    );
  }
}

export class ColorRouter extends React.PureComponent<PropsFromParent> {
  private iconStyle = { color: this.props.color };
  public render() {
    return (
      <div className="flexDirectionRow">
        <RouterRoundedIcon style={this.iconStyle} className="enlarge" />
      </div>
    );
  }
}
